import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type TemplateFromConstructionInput,
	templateFromConstruction,
} from "@/adapters/api";

export function useTemplateFromConstruction() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: TemplateFromConstructionInput) =>
			templateFromConstruction(input),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["stage-templates"] });
		},
	});
}
